module.exports = require('./helpers/bundle-url').getBundleURL('gIXIs') + "logo.7718c6df.svg";